String.prototype.containsPostalCode = function () {
  return this.match(/^\D*\d{5}(\s.*)?$/) !== null;
}
String.prototype.returnPostalCode = function () {
  let match = this.match(/\D*(\d{5})\D*/);
  return match[0];
}
String.prototype.escapeForRegExp = function () {
  return this.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}
